<template>
  <div>
    <!-- mobile menu -->
    <div v-if="isMobileDevice"
         class="ui compact menu mobile-menu">
      <a class="item"
         @click="openProfileAllInOneModal">
        {{ trans.profileMenu }}
      </a>
      <!--<a class="item" @click="openProfileModal">-->
      <!--<i class="user icon"></i>-->
      <!--</a>-->
      <!--<a class="item" @click="openReservationModal">-->
      <!--<i class="calendar icon"></i>-->
      <!--</a>-->
      <!--<a class="item" @click="openPassesModal">-->
      <!--<i class="sticky note icon"></i>-->
      <!--</a>-->
      <a class="item"
         @click="logOut">
        {{ trans.logOutMenu }}
      </a>
    </div>
    <!-- ./mobile menu -->
    <!-- desktop menu -->
    <div v-else=""
         class="ui secondary menu">
      <menu-logo/>
      <!--
      <div class="item">Egyenleg: {{ user.balance }} Ft</div>
      -->
      <div class="right menu">
        <!--<h5 class="menu-text-align">{{ user.name }}</h5>-->
        <button class="m-button"
                @click="openProfileAllInOneModal">
          <!--<i class="user outline icon"></i>-->{{ trans.profileMenu }}
        </button>
        <!--<button class="m-button" @click="openProfileModal">-->
        <!--&lt;!&ndash;<i class="user outline icon"></i>&ndash;&gt;PROFIL-->
        <!--</button>-->
        <!--<button class="m-button" @click="openReservationModal">-->
        <!--&lt;!&ndash;<i class="calendar alternate outline icon"></i>&ndash;&gt;FOGLALÁSAIM-->
        <!--</button>-->
        <!--<button class="m-button" @click="openPassesModal">-->
        <!--&lt;!&ndash;<i class="user book icon"></i>&ndash;&gt;BÉRLETEIM-->
        <!--</button>-->
        <button class="m-button"
                @click="logOut">
          <!--<i class="sign out icon"></i>-->{{ trans.logOutMenu }}
        </button>
      </div>
    </div>
    <!-- ./desktop menu -->
  </div>

</template>

<script>
import MenuLogo from './components/MenuLogo'
import {mapState} from 'vuex'
/* eslint-disable */
export default {
  props: ['user', 'isMobileDevice'],
  methods: {
    openPassesModal () {
      this.$emit('get-guest-passes', false)
    },
    logOut () {
      this.$emit('logout')
    },
    openProfileModal () {
      this.$modal.show('profile-modal')
    },
    openProfileAllInOneModal () {
      this.$emit('open-all-in-one-modal')
    },
    openReservationModal () {
      this.$emit('get-user-reservations')
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.topMenu,
    }),
  },
  components: {
    MenuLogo,
  },
}
</script>

<style scoped>
.ui.menu {
  /* padding-bottom: .3rem; */
  /* padding-left: 1rem; */
  /* padding-top: .3rem; */
  /* width: 100%; */
  /* margin-bottom: 500px; */
  padding: 0.3rem 0 0.3rem 0;
  border-bottom: 1px solid rgba(34, 36, 38, .15);
  /*background: #ffffffe0;*/
  position: fixed;
  top: 0;
  z-index: 99;
  left: 0;
  right: 0;
  height: 3rem;
  /*
  background: #FF9000;
  */
  background: rgba(255, 156, 0, 0.8);
}


.ui.menu.mobile-menu {
  width: 100%;
  margin-bottom: 0.3rem !important;
  border-radius: 0;
  padding: 0;
  border: none;
  background: rgb(255, 156, 0);
  font-size: 150%;
}

.ui.menu:not(.vertical) .item {
  width: 50%;
  padding-left: 10%;
}

.ui.secondary.menu {
  padding-left: 10rem;
  padding-right: 10rem;
}

.menu-space-helper {
  content: ' ';
  height: 3.5rem;
}

.right.menu {
  padding: 0;
  background: #ffffff00;
}

.black-button {
  margin-right: 1rem;
  color: rgba(0, 0, 0, .87);
  font-weight: 600;
  letter-spacing: 0.2px;
  text-decoration: underline;
  cursor: pointer;
}

.black-button:hover {
  text-decoration: none;
}

.black-button:focus {
  outline: 0;
}

.menu-text-align {
  padding-top: 0.5rem;
  margin-right: 1rem;
  color: white;
}

.m-button {
  margin-right: 1rem;
  color: white;
  font-weight: 300;
  letter-spacing: 0.2px;
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;
  cursor: pointer;
}

.m-button:focus {
  outline: none;
}

</style>
